module.exports = __webpack_public_path__ + "assets/img/ic-info-g.bb608341.svg";